import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { RegisterUserComponent } from './register-user/register-user.component'
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

import { MaterialsModule } from '../../../modules/materials.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { InvalidTokenComponent } from './register-user/invalid-token/invalid-token.component';
import { SuccessComponent } from './register-user/success/success.component';

@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    RegisterUserComponent,
    ForgotPasswordComponent,
    InvalidTokenComponent,
    SuccessComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    MaterialsModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
  ]
})
export class AuthModule { }
